import { authedRequest } from './requests'
import { normalize, schema } from 'normalizr';

// Define schema
const client = new schema.Entity('clients');

const clientList = [client];

/**
 *
 * /clients resource requests
 *
 */
export const getClients =
  (token, { q }) =>{
    return authedRequest(`v2/clients?q=${q}`, token)
      .then(r => normalize(r, clientList).entities)};
